module.exports = __webpack_public_path__ + "img/para_muros_de_poliestireno.a433e5f4.png";